export default {
    type: 'numeric',
    format: {
        decimals: 2,
        min: 1,
        max: 5
    },
    default: {
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Weight',
        category: 'BGG',
        description: 'Community average complexity rating of the game.',
        summarise: {
            prefix: 'BGG weight'
        }
    },
    rules: {
        linked: [],
        legacy: ['weight']
    }
}